import styled, { css } from 'styled-components';
import { NavLink } from 'react-router-dom';

import { cFFFFFF } from '#/colors';

import { PORTFOLIO_ROUTE, FUTURES_ROUTE } from '#/routes';

import { gradientUnderline } from '#/components/shared/styles';
import { verticalSpacerCss } from '#/components/shared/Spacer';
import NotificationsButton from '#/components/common/notifications/NotificationsButton';

import DevelopersMenu from './DevelopersMenu';
import SocialsMenu from './SocialsMenu';
import EnvironmentMenu from './EnvironmentMenu';
import { navItemStyles } from './styles';

export interface Props {
  readonly className?: string;
}

export default function Nav(props: React.PropsWithChildren<Props>) {
  const { className, children } = props;

  return (
    <Container className={className}>
      <MainNav id="main-nav" aria-label="Main menu">
        <li>
          <NavItemLink to={PORTFOLIO_ROUTE}>Portfolio</NavItemLink>
        </li>
        <li>
          <NavItemLink to={FUTURES_ROUTE}>Futures</NavItemLink>
        </li>
        {/* Removed from view while not available to not confuse users */}
        {/* <li>
          <NavItem to={OPTIONS_ROUTE}>Options</NavItem>
        </li> */}
        <li>
          <DevelopersMenu />
        </li>
        <div css="flex-grow: 1;" />
      </MainNav>
      <SecondaryNav id="secondary-nav" aria-label="Secondary menu">
        {children}
        <li>
          <EnvironmentMenu />
        </li>
        <li>
          <SocialsMenu />
        </li>
        <li>
          <NotificationsButton />
        </li>
      </SecondaryNav>
    </Container>
  );
}

const Container = styled.nav`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const MainNav = styled.ul`
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  gap: 40px;
`;

const verticalSpacerBefore = css`
  &:before {
    content: '';
    display: block;
    position: relative;
    left: -15px;
    ${verticalSpacerCss}
  }
`;

const SecondaryNav = styled.ul`
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  gap: 30px;

  li {
    display: flex;
    align-items: center;
    &:not(:first-child) {
      ${verticalSpacerBefore}
    }
  }
`;

export const NavItemLink = styled(NavLink)`
  ${navItemStyles}

  &.active {
    color: ${cFFFFFF};
    ${gradientUnderline}
  }
`;
